<template>
  <div class="mx-auto max-w-rxl sm:px-6 lg:px-8">
    <div class="overflow-hidjen bg-white shadow-xl border-solid border border-gray-200 px-7 py-7 sp:px-3 sp:py-3">
      <div class="w-full text-right">
        <template v-if="!questionListMenu">
          <button
            v-if="onResize"
            class="bg-gray-500 lg:hover:bg-gray-300 active:bg-gray-300 duration-300 text-white py-3 px-4 text-xs my-1 rounded-lg"
            @click="onClickedQuestionListMenu">
            <p class="flex items-center">
              解答リスト
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
            </p>
          </button>
        </template>
      </div>
      <div class="flex justify-between items-center text-xl mb-2 mr-3">
        <div class="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            v-bind="timerIconClass()"
            class="h-6 w-6 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <timer
            :type="type"
            :examination="props.examination"
            :start-answer-time="startAnswerTime"
            :set-limit-seconds="setLimitSeconds" />
        </div>
        <div class="flex items-center">
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-green-400 mr-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div class="text-gray-400 text-lg font-bold">
              {{ countAnswer }} / {{ props.allQuestions.length }}
            </div>
          </div>
        </div>
      </div>
      <progress-bar
        :remaining-time-percent="remainingTimePercent" />
      <h2 class="text-lg font-black">{{ `第${ questionIndex + 1 }問目` }}</h2>
      <p class="text-md mt-2 whitespace-pre-wrap">
        {{ props.allQuestions[props.questionIndex].question ?? '' }}
      </p>
      <img
        v-if="props.allQuestions[props.questionIndex].image_path_question"
        class="mx-auto w-96 mt-10"
        :src="imgPath">
    </div>
    <div
      v-for="(value, key, index) in partialQuestion"
      :key="key"
      v-bind="onRowClickedReturnAttribute(index)"
      class="flex cursor-pointer p-6 sp:p-2 sp:text-sm overflow-hidden bg-white hover:bg-gray-200 duration-300 border border-gray-200 shadow-xl sm:rounded-none"
      @click="rowClicked(index)">
      <p>{{ index + 1 }}: {{ value }}</p>
    </div>
    <div class="flex justify-around bg-gray-100 border-solid border border-gray-200 shadow-xl p-6 sp:p-3">
      <button
        v-if="questionIndex"
        class="bg-white duration-300 py-2.5 px-10 rounded-lg sp:text-sm sp:px-7 border border-gray-300"
        @click="onBackQuestion">
        前の問題
      </button>
      <button
        v-if="allQuestions.length === questionIndex + 1"
        class="bg-red-500 lg:hover:bg-red-300 active:bg-red-300 duration-300 text-white py-2.5 px-10 sp:px-7 sp:text-sm rounded-lg"
        @click="$emit('confirmation')">
        終了する
      </button>
      <button
        v-if="allQuestions.length > questionIndex + 1"
        class="bg-blue-600 lg:hover:bg-blue-400 active:bg-blue-400 duration-300 sp:text-sm sp:px-7 text-white py-2.5 px-10 rounded-lg"
        @click="onNextQuestion">
        次の問題
      </button>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import {
  ref, reactive, computed, watch, onUnmounted, onMounted,
} from 'vue'
import moment from 'moment'
import Timer from './Timer'
import ProgressBar from './ProgressBar'

const props = defineProps({
  allQuestions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: Number,
    default: 0,
  },
  countAnswer: {
    type: Number,
    default: 0,
  },
  answersArr: {
    type: Array,
    default: () => [],
  },
  startAnswerTime: {
    type: String,
    default: '',
  },
  limitTimes: {
    type: Object,
    default: () => {},
  },
  onResize: {
    type: Boolean,
    default: false,
  },
  questionListMenu: {
    type: Boolean,
    default: false,
  },
  questionIndex: {
    type: Number,
    default: 0,
  },
  isSelectCondition: {
    type: Boolean,
    default: true,
  },
  selectAnswer: {
    type: Object,
    default: () => {},
  },
})

const emit = defineEmits(['button-click', 'sum-index', 'on-clicked-question-list-menu', 'confirmation', 'assign-answer'])
const onClickedQuestionListMenu = () => {
  emit('on-clicked-question-list-menu')
}

const partialQuestion = computed(() => {
  const choicesArray = []
  const allQuestions = props.allQuestions[props.questionIndex]
  props.allQuestions[props.questionIndex].pivot.choices_order.map(element => {
    switch (element) {
      case 1:
        choicesArray.push(allQuestions.correct_answer)
        break
      case 2:
        choicesArray.push(allQuestions.dummy_answer1)
        break
      case 3:
        choicesArray.push(allQuestions.dummy_answer2)
        break
      case 4:
        choicesArray.push(allQuestions.dummy_answer3)
        break
      case 5:
        choicesArray.push(allQuestions.dummy_answer4)
        break
      default:
        break
    }

    return choicesArray
  })

  return {
    answer1: choicesArray[0] ?? '',
    answer2: choicesArray[1] ?? '',
    answer3: choicesArray[2] ?? '',
    answer4: choicesArray[3] ?? '',
    answer5: choicesArray[4] ?? '',
  }
})

const imgPath = computed(() => `/img/${props.allQuestions[props.questionIndex].image_path_question}`)

const onRowClickedReturnAttribute = (selectIndex) => {
  let style
  if (props.answersArr && props.isSelectCondition) {
    const isQuestionId = props.answersArr.find(answer => answer.question_id === props.allQuestions[props.questionIndex].id)
    if (isQuestionId) {
      if (isQuestionId.answer_type === props.allQuestions[props.questionIndex].pivot.choices_order[selectIndex]) {
        style = { class: 'bg-gray-300 text-md font-bold' }
      }
    }
  } else if (props.selectAnswer.answer_type === props.allQuestions[props.questionIndex].pivot.choices_order[selectIndex]) {
    style = { class: 'bg-gray-300 text-md font-bold' }
  }
  return style
}

const rowClicked = (index) => {
  emit('assign-answer', index)
}

const clearHistory = () => {
  window.history.pushState(null, null, window.location.href)
  window.addEventListener('popstate', () => {
    window.history.pushState(null, null, window.location.href)
  })
}

const onNextQuestion = () => {
  emit('sum-index', 1)
  clearHistory()
  emit('button-click')
}

const endQuestion = computed(() => props.allQuestions[props.allQuestions.length - 1])

const onEndQuestion = () => {
  clearHistory()
  emit('button-click')
}

const onBackQuestion = () => {
  emit('sum-index', -1)
  clearHistory()
  emit('button-click')
}

const timeToSecond = ref(0)
const setLimitSeconds = computed(() => {
  if (props.examination.is_subscription_item) {
    return props.limitTimes[props.type] / 2
  }
  return props.limitTimes[props.type]
})

const remainingTimePercent = computed(() => {
  const progressDegrees = timeToSecond.value / setLimitSeconds.value
  return Math.round(progressDegrees * 100)
})

const diffCurrentTimeFromStartTime = () => {
  const now = moment().format('YYYY-MM-DD HH:mm:ss')
  timeToSecond.value = moment(now).diff(props.startAnswerTime, 'seconds')
}

const timerId = ref(0)
const countDown = () => {
  timerId.value = setInterval(diffCurrentTimeFromStartTime, 1000)
}
countDown()

const timerIconClass = () => {
  if (remainingTimePercent.value > 80) return { class: 'text-red-400' }
  if (remainingTimePercent.value > 60) return { class: 'text-yellow-400' }
  if (remainingTimePercent.value > -1) return { class: 'text-green-400' }
  return {}
}

onUnmounted(() => {
  clearInterval(timerId.value)
})
</script>
